
<div class="report-content">
  <div v-if="isLoading" class="d-flex justify-content-center align-items-center py-4 h-100">
    <v-progress-circular color="primary" indeterminate></v-progress-circular>
  </div>

  <div v-else-if="!allReportFields.length" class="w-100 h-100 d-flex justify-content-center align-items-center">
    <i class="ma-0">Please thick check column data or select report template on the left side to show the exported
      column here.</i>
  </div>

  <div class="" v-else>
    <div class="filter-container position-absolute w-100">
      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center" v-if="selectedExportReport.name !== 'Quick'">
          <div class="filter">
            <v-menu v-model="isMenuOpen" min-width="300px" bottom :close-on-content-click="false" nudge-bottom="24px">
              <template v-slot:activator="{ on, attrs }">
                <div class="d-flex justify-content-between align-items-center" role="button" v-bind="attrs" v-on="on">
                  <span>Filter <span class="badge badge-primary ml-2" style="line-height: inherit;">{{
                    totalAppliedFilters }}</span></span>
                  <v-icon color="#3F3F3F" small>mdi-chevron-down</v-icon>
                </div>
              </template>
              <div class="bg-white p-3" style="height: 542px; overflow: auto; width: 400px; margin-bottom: 46px;">
                <!-- Custom Filter -->
                <ColumnFilter @close-menu="isMenuOpen = false" />
              </div>
            </v-menu>
          </div>
          <h5 class="ma-0 ml-3">Total <b>{{ formattedDataCount }}</b> data based on the applied filters.</h5>
        </div>
        <div :class="{ 'ml-auto': selectedExportReport.name === 'Quick' }" v-if="exportSelect !== 'collection'">
          <ColumnPagination />
        </div>
      </div>
      <div v-if="isShowLegend" class="legend my-4 d-flex" style="gap: 32px; color: #3F3F3F;">
        <v-tooltip bottom open-on-hover color="white" content-class="bg-white custom-tooltip">
          <template v-slot:activator="{ on }">
            <div v-on="on" class="actual-data d-flex align-items-center">
              <div style="width: 24px; height: 24px; background-color: #EDF4FE; border: 1px solid #D7D7D7"></div>
              <b class="ml-2">Actual Data Column</b>
            </div>
          </template>
          <span class="d-flex flex-column" style="background-color: #FFFFFF !important;">
            <b>Actual Data Column</b>
            <span style="font-size: 12px;">This is your organization's real data and will be included in the
              export</span>
          </span>
        </v-tooltip>
        <v-tooltip bottom open-on-hover color="white" content-class="bg-white custom-tooltip">
          <template v-slot:activator="{ on }">
            <div v-on="on" class="sample-data d-flex align-items-center">
              <div style="width: 24px; height: 24px; background-color: #D7D7D7; border: 1px solid #D7D7D7"></div>
              <b class="ml-2">Sample Data Column</b>
            </div>
          </template>
          <span class="d-flex flex-column" style="background-color: #FFFFFF !important;">
            <b>Sample Data Column</b>
            <span style="font-size: 12px;">This is sample data for preview only. The exported report will show real
              data</span>
          </span>
        </v-tooltip>
      </div>
    </div>
    <div class="nav-container">
      <button v-if="isShowNav" class="btn-vertical prev"
        :class="{ 'btn-vertical-primary': fieldPagination.current_page > 1 }"
        @click="goToPage(fieldPagination.current_page - 1)">
        <v-icon :color="fieldPagination.current_page > 1 ? '#FFF' : '#D7D7D7'">mdi-chevron-left</v-icon>
      </button>
      <button v-if="isShowNav" class="btn-vertical next"
        :class="{ 'btn-vertical-primary': fieldPagination.current_page < fieldPagination.total_pages }"
        @click="goToPage(fieldPagination.current_page + 1)">
        <v-icon
          :color="fieldPagination.current_page < fieldPagination.total_pages ? '#FFF' : '#D7D7D7'">mdi-chevron-right</v-icon>
      </button>
    </div>
    <div class="column-container" :style="{ marginTop: isShowLegend ? '108px' : '74px' }">
      <div class="position-relative" style="width: fit-content;">

        <div class="d-flex">
          <div v-for="(column, index) in processedColumns" :key="index" class="column-item">
            <div class="column-card">
              <div class="column-header" :class="{ 'data-dummy': column.isDummy || column.isCollection }">
                <v-tooltip v-if="!column.isDummy && !column.isCollection" bottom content-class="tooltip">
                  <template v-slot:activator="{ on, attrs }">
                    <h4 v-on="on" class="ma-0"
                      style="font-size: 16px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                      <b>{{ getColumnLabel(column) }}</b>
                    </h4>
                  </template>
                  <span style="background-color: white;">
                    <p class="ma-0">{{ getColumnLabel(column) }}</p>
                    <i style="color: #848484; font-size: 12px;">
                      <b>Original Column Name :</b>
                      {{ column.original_header_name }}
                    </i>
                  </span>
                </v-tooltip>
                <div v-else class="d-flex">
                  <v-icon small color="#3F3F3F" class="mr-2"
                    style="padding: 2.5px 0;">mdi-file-document-edit-outline</v-icon>
                  <h4 class="ma-0"
                    style="font-size: 16px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                    <b>{{ getColumnLabel(column) }}</b>
                  </h4>
                </div>
              </div>
              <div class="content-container"
                :style="{ backgroundColor: column.isDummy || column.isCollection ? '#F4F4F4' : '#FFFFFF' }">
                <div v-if="column.isQuestionnaire">
                  <template v-if="column.previewData.length">
                    <div class="content-preview" v-for="(item, index) in column.previewData" :key="index">
                      <h4 class="ma-0" style="font-size: 16px;">
                        <span v-if="item || item === 0">{{ item }}</span>
                        <i v-else class="text-muted" style="color: #DDDDDD !important;">Empty</i>
                      </h4>
                    </div>
                  </template>
                  <div v-else>
                    <i class="text-muted text-center d-block" style="color: #BDBDBD !important;">Preview unavailable.
                      Ensure
                      your organization has data to display.</i>
                  </div>
                </div>
                <div class="d-flex justify-content-center align-items-center" style="height: 800px; color: #007BFF;"
                  v-else-if="!showPreview[column.id]">
                  <button @click="togglePreview(column)" class="d-flex align-items-center">
                    <v-icon small color="#007BFF" class="mr-2" style="height: fit-content;">mdi-eye-outline</v-icon>
                    Show Preview Data
                  </button>
                </div>
                <div v-if="showPreview[column.id]">
                  <template v-if="previewData[`${column.id}`] && previewData[`${column.id}`].length > 0">
                    <div class="content-preview" v-for="(item, index) in previewData[column.id]" :key="index">
                      <h4 class="ma-0" style="font-size: 16px;">
                        <span v-if="item || item === 0">
                          <template v-if="column.column_name === 'prevailing_wage_cents'">
                            {{ formatCurrency(item) }}
                          </template>
                          <template v-else>
                            {{ item }}
                          </template>
                        </span>
                        <i v-else class="text-muted" style="color: #DDDDDD !important;">Empty</i>
                      </h4>
                    </div>
                  </template>
                  <div v-else>
                    <i class="text-muted text-center d-block" style="color: #BDBDBD !important;">Preview unavailable.
                      Ensure
                      your organization has data to display.</i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
